// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Q8-o3","content":"styles_content__1xASb","tableWrap":"styles_tableWrap__1n5rM"};